import React from "react";
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";

const ApprovalPending = () => {
  return (
    <>
      <SellerNavbar />
      <div className="container-fluid">
        <div className="row my-3 g-2">
          <div className="col-md-2">
            <SellerSidebar />
          </div>

          <div className="col-md-10 d-flex justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
            <div className="card text-center p-5 shadow-sm" style={{ maxWidth: "600px" }}>
              <h2 className="mb-3 text-warning">Account Approval Pending</h2>
              <p className="mb-4">
                Your seller account is currently under review by our administration team.
              </p>
              <p className="mb-4">
                Please allow <strong>1-2 business days</strong> for your account to be approved.
              </p>
              <p className="mb-4">
                Once approved, you will be able to create listings and manage your products on the platform.
              </p>
              <div className="text-center">
                <span className="badge bg-info text-dark p-3">
                  Approval Pending
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApprovalPending;
